function JobCategoriesEducationIcon({ color = "#191515" }) {
  return (
    <svg
      width="38"
      height="48"
      viewBox="0 0 60 60"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clip-path="url(#clip0_1106_1708)">
        <path
          d="M16.8204 48.8282H12.1114C10.8632 48.8282 9.66668 49.3239 8.78449 50.2062C7.90242 51.0886 7.40625 52.2853 7.40625 53.5332C7.40625 53.5344 7.40625 53.5351 7.40625 53.5351V6.46488C7.40625 5.2166 7.90242 4.0193 8.78449 3.13652C9.66762 2.25375 10.8652 1.75781 12.1134 1.75781C14.4669 1.75781 16.8205 1.75781 16.8205 1.75781L16.8204 48.8282Z"
          stroke={color}
          stroke-width="5"
          stroke-miterlimit="10"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M52.5937 58.2421H12.1113C9.51305 58.2421 7.40625 56.1357 7.40625 53.537C7.40625 53.5358 7.40625 53.5345 7.40625 53.5332C7.40625 50.9347 9.51316 48.8281 12.1113 48.8281C23.6831 48.8281 52.5936 48.8281 52.5936 48.8281L52.5937 58.2421Z"
          stroke={color}
          stroke-width="5"
          stroke-miterlimit="10"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M52.5938 1.75781H16.8203V48.8282H52.5938V1.75781Z"
          stroke={color}
          stroke-width="5"
          stroke-miterlimit="10"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_1106_1708">
          <rect width="60" height="60" fill={color} />
        </clipPath>
      </defs>
    </svg>
  );
}

export default JobCategoriesEducationIcon;
